import { Spin, Flex, Title } from '@bb/elements-web';
import React from 'react';
import { StyledCard, StyledText } from './styledComponents';

export default function SingleAccessSubmittingCard() {
  return (
    <StyledCard $centerText $noPadding>
      <Flex gap={24} vertical align="center">
        <Spin
          dataCy="single-access-loading-spin"
          size="large"
          style={{
            width: '64px',
            height: '64px',
            margin: 'auto',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        />
        <Flex gap={8} vertical align="center">
          <Title
            dataCy="single-access-loading-title"
            level={4}
            textAlign="center"
            margin={0}
          >
            Checking your email
          </Title>
          <StyledText $secondary size="large" $alignCenter>
            Hang tight while we look things up
          </StyledText>
        </Flex>
      </Flex>
    </StyledCard>
  );
}
